
import React from 'react';
import { Search, X } from 'lucide-react';

interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div className="mt-6 mb-8 flex justify-center">
      <div className="relative w-full max-w-lg transition-all duration-300 focus-within:max-w-xl">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-purple-400" size={18} />
        <input
          type="text"
          placeholder="Search success stories..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10 pr-10 py-3 w-full rounded-full border border-purple-200 
                    focus:outline-none focus:ring-2 focus:ring-purple-300 
                    shadow-sm hover:shadow transition-all bg-white/90 backdrop-blur-sm"
        />
        {searchTerm && (
          <button 
            onClick={() => setSearchTerm('')}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-purple-400 hover:text-purple-600 transition-colors"
            aria-label="Clear search"
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
